/**
 * Uloží nebo otevře blob jako soubor.
 *
 * @param {Blob} blob - blob
 * @param {Object} [options] - volitelné parametry
 * @param {string} [options.filename] - jméno souboru
 * @param {string} [options.contentType] - typ obsahu
 */
export default function saveOrOpenBlob(blob, options = {}) {
  // Zdroj:
  // - https://stackoverflow.com/a/19328891
  // - https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript
  if (options.contentType != null) {
    blob = blob.slice(0, blob.size, options.contentType);
  }

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, options.filename);
    return;
  }

  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;

  if (options.filename != null) {
    anchor.download = options.filename;
  }

  document.body.appendChild(anchor); // Kvůli Firefoxu, Chrome to nepotřebuje

  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 100); // Zpoždění kvůli Firefoxu
}
